import PropTypes from 'prop-types';
// @mui
import { Box, Card, Link, Typography, Stack } from '@mui/material';
import { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
// components
import Label from '../components/label';
import { ColorPreview } from '../components/color-utils';

// ----------------------------------------------------------------------

const StyledProductImg = styled('img')({
  top: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
});

// ----------------------------------------------------------------------

export default function HuntingClubMapa(props) {
  // const { naziv, mjesto, adresa, telefon, predsjednik, sekretar, karta } = huntingclub;
  
  useEffect(() => {
		console.log(props.huntingclub);
		console.log(props.huntingclub.naziv);
  });


  return (
    <Card sx={{ backgroundColor: "#16215c", color: "#fff", p: 2 }}>
      <Box sx={{ pt: '100%', position: 'relative' }}>
        <StyledProductImg alt={props.huntingclub.naziv} src={props.huntingclub.photoUrl} />
      </Box>

      <Stack spacing={2} sx={{ p: 3 }}>
        <Link color="inherit" underline="hover">
          <Typography align="center" variant="subtitle3" noWrap>
            {props.huntingclub.name}
          </Typography>
        </Link>

        <Stack direction="column" alignItems="left" justifyContent="space-between">
		  <Typography variant="subtitle2" noWrap>
            Company: {props.huntingclub.company.name}
          </Typography>
		  
		  <Typography variant="subtitle2" noWrap>
            Zona: {props.huntingclub.company.address}
          </Typography>
          		  
        </Stack>
      </Stack>
    </Card>
  );
}
